exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unverified-user-alert-component .alert{position:fixed!important;width:100%!important;z-index:1000!important;border:none!important;color:#fff!important;background-color:#dc3545!important;-webkit-transition:all .2s ease}", ""]);

// exports
